<template>
  <div
    :class="cssClasses"
    @click.prevent="openDayPopup">
    <span class="day-number">
      {{ dayNumber }}
    </span>
    <br>
    <span
      v-if="ordersData"
      class="day-info">
      <span>
        <i class="material-icons">shopping_cart</i> {{ ordersData.orders_qty }}
      </span>
      <span :class="{
        'ml-auto': true,
        'text-danger': ordersData.qty > 3500,
        'text-warning': ordersData.qty > 2500 && ordersData.qty <= 3500,
        'text-success': ordersData.qty <= 2500
      }">
        <i class="material-icons">circle</i>
        {{ ordersData.qty }}
      </span>
    </span>
  </div>
</template>
<script>

export default {
  name: 'calendar-day',
  props: [
    'dayData',
    'isCurrentDay',
    'ordersData'
  ],
  computed: {
    isPastDay () {
      if (this.dayData.isToday) {
        return false;
      }

      let dateParts = this.dayData.date.split('-').map(n => parseInt(n, 10));
      let dateObject = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      let today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setMilliseconds(0);

      if (dateObject < today) {
        return true;
      }

      return false;
    },
    cssClasses () {
      if (this.dayData) {
        return {
          'day': true,
          'is-today': this.dayData.isToday,
          'is-different-month': !this.dayData.isCurrentMonth,
          'is-past': this.isPastDay
        };
      }

      return {
        'day': true,
        'is-current': this.isCurrentDay
      };
    },
    dayNumber () {
      if (this.dayData) {
        return this.dayData.number;
      }

      return '-';
    }
  },
  methods: {
    openDayPopup () {
      let date = this.dayData.date;
      this.$bus.$emit('services-schedule-open-day-popup', date);
    }
  }
}
</script>

<style lang="scss" scoped>
.day {
  border-right: 1px solid #e1e5eb;
  border-bottom: 1px solid #e1e5eb;
  cursor: pointer;
  height: 110px;
  padding: 1rem;
  position: relative;
  width: calc(100% / 7);

  &:nth-child(7n) {
    border-right: none;
  }

  &:hover {
    background: lighten(#007bff, 42.5%);

    &:before {
      border: 3px solid #007bff;
      border-radius: 5px;
      content: "";
      height: calc(100% + 6px);
      position: absolute;
      pointer-events: none;
      right: -3px;
      top: -3px;
      width: calc(100% + 6px);
      z-index: 1;
    }
  }

  .day-info {
    bottom: 1rem;
    display: flex;
    font-size: .75rem;
    position: absolute;
    width: calc(100% - 2rem);
  }

  &.is-today {
    background: #ffb4001c;
  }

  &.is-current {
    background: #00b8d8;
    border-color: #00b8d8;
    color: #CACEDB;

    &:after {
      border: 10px solid #00b8d8;
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      content: "";
      left: calc(50% - 10px);
      position: absolute;
      top: -20px;
    }
  }

  &.is-different-month {
    background: #f7f7f7;

    span {
      opacity: .1;
    }
  }

  &.is-past {
    & > * {
      opacity: .35;
    }
  }

  &-number {
    font-size: 1.5rem;
  }

  &-closed {
    bottom: 1.8rem;
    color: #c4183c;
    font-size: 1.3rem;
    font-weight: bold;
    opacity: .75;
    position: absolute;
    right: 1rem;
  }
}
</style>
